import { render, staticRenderFns } from "./FeedbackBar.vue?vue&type=template&id=58303ba2&scoped=true&"
import script from "./FeedbackBar.vue?vue&type=script&lang=js&"
export * from "./FeedbackBar.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackBar.vue?vue&type=style&index=0&id=58303ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58303ba2",
  null
  
)

export default component.exports